export default [{
  id: 'webAppRegistrationProcess',
  title: 'Web/App Registration Process',
}, {
  id: 'mobileAppsInitialLogin',
  title: 'Mobile Apps initial Login',
}, {
  id: 'loginAfterMobileAppsUpdate',
  title: 'Login after Mobile Apps update',
}, {
  id: 'acquisitionConnectTarif',
  title: 'Acquisition Connect Tarif',
}, {
  id: 'purchaseOfFurtherConnection',
  title: 'Purchase of further connection',
}, {
  id: 'purchaseOfMulticard',
  title: 'Purchase of Multicard',
}, {
  id: 'hardwareOnly',
  title: 'Hardware only',
}, {
  id: 'packsForConnectionsPurchaseUpgrade',
  title: 'Packs for connections (purchase/upgrade)',
}, {
  id: 'packsForConnectionsDowngrade',
  title: 'Packs for connections (downgrade)',
}, {
  id: 'vasForConnections',
  title: 'VAS for connections',
}, {
  id: 'specialServices',
  title: 'Special Services (Sky)',
}, {
  id: 'webAppLogin',
  title: 'Web/App Login',
}, {
  id: 'inlifeCrmCampaign',
  title: 'Inlife CRM Campaign',
}, {
  id: 'inlifeEventVvl',
  title: 'Inlife Event VVL',
}, {
  id: 'inlifeEventOnlineInvoiceDownload',
  title: 'Inlife Event online invoice download',
}, {
  id: 'inlifeEventConsentMaintenance', // added for completeness reasons
  title: 'Inlife Event consent maintenance',
}, {
  id: 'consentConfirmationNote',
  title: 'Consent Confirmation Note',
}, {
  id: 'existingCustomerInlifeMaintenance',
  title: 'Inlife Event for existing customer consent maintenance',
}, {
  id: 'existingCustomerInlifeMaintenanceView',
  title: 'View mode for existing customer consent maintenance',
}, {
  id: 'existingCustomerSalesCampaign',
  title: 'Sales Campaign for existing Customers',
}, {
  id: 'onlineOrder',
  title: 'Online Order',
}, {
  id: 'customerService',
  title: 'All Consents (for using in CS-app)',
}, {
  id: 'existingCustomerMaintenanceCustomerService',
  title: 'All Consents (for using in CS-app) without OGW global consents',
}, {
  id: 'customerServiceCampaign',
  title: 'Customer Service Campaign',
}, {
  id: 'businessProspectCustomer',
  title: 'Prospect Customer in B2B stack',
}, {
  id: 'businessNewCustomer',
  title: 'New Customer in B2B stack (agents)',
}, {
  id: 'businessExistingCustomerVvl',
  title: 'Existing Customer (VVL) in B2B stack',
}, {
  id: 'businessExistingCustomerInlife',
  title: 'Existing Customer (Inlife) in B2B stack',
}, {
  id: 'businessFormerCustomer',
  title: 'Former Customer in B2B stack',
}, {
  id: 'businessWebNewCustomer',
  title: 'New Customer in B2B stack (customers)',
}, {
  id: 'inlifeEventForRoA',
  title: 'All consents for RoA',
}, {
  id: 'inlifeEventConsentMaintenanceView',
  title: 'View mode for selfcare in microfrontend ',
}, {
  id: 'testLifecycle',
  title: 'Test lifecycle for Config-Testing',
}, {
  id: 'inlifeEventPriority',
  title: 'Lifecycle for o2more/priority',
}, {
  id: 'webRegistrationCCI',
  title: 'lifeCycle for collecting new customer consents in CustomerService',
}, {
  id: 'inlifeCrmCampaignOvl',
  title: 'Lifecycle for customer campaign in selfcare / OVL',
}, {
  id: 'shopRegistrationTCM',
  title: 'Lifecycle for tchibo shop registration',
}, {
  id: 'newCustomerErlaubnisse',
  title: 'Lifecycle with only optins for new customers',
}, {
  id: 'businessExistingCustomerOrderForm',
  title: 'Existing business customer informations for order form',
}, {
  id: 'businessNewCustomerOrderForm',
  title: 'New business customer informations for order form',
}, {
  id: 'businessProspectCustomerOrderForm',
  title: 'Prospect business customer informations for order form',
}, {
  id: 'businessWebExistingCustomerInlife',
  title: 'Existing Customer (Web Inlife) in B2B stack',
}, {
  id: 'businessWebExistingCustomerInlifeView',
  title: 'View mode for existing Customer (Web Inlife) in B2B stack',
}, {
  id: 'businessExistingCustomerChangeOrderForm',
  title: 'Existing business customer informations for change order form',
}, {
  id: 'printServiceShopFull',
  title: 'for use cases, where pseudo consents and consents are collected / managed (ePOS)',
}, {
  id: 'printServiceShopPartial',
  title: 'for use cases, where only pseudo consents are collected / managed (ePOS)',
}, {
  id: 'printServicePartnerFull',
  title: 'for use cases, where pseudo consents and consents are collected / managed (MCE)',
}, {
  id: 'printServicePartnerSpecial',
  title: 'for special use cases, e.g. PowWow (MCE)',
}, {
  id: 'printServicePartnerPartial',
  title: 'for use cases, where only pseudo consents are collected / managed (MCE)',
}, {
  id: 'printServiceHotlinePartial',
  title: 'for CCI / Salcus',
}, {
  id: 'existingCustomerTvPackFirstTimeUsage',
  title: 'lifecycle for o2TV Pack first usage',
}, {
  id: 'existingCustomerTvPackMaintenance',
  title: 'inlife event for o2TV Pack consents',
}, {
  id: 'existingCustomerTvPackMaintenanceView',
  title: 'inlife event view for o2TV Pack consents',
}, {
  id: 'existingCustomerInlifeVVL',
  title: 'Lifecycle for ShopDPS',
}, {
  id: 'existingCustomerUnsubscribe',
  title: 'LifeCycle for unsubscribe',
}, {
  id: 'inlifeEventMergeAccounts',
  title: 'LifeCycle for merge accounts',
}, {
  id: 'existingCustomerPartnerServiceMaintenance',
  title: 'Inlife Event for existing partner customer consent maintenance ',
}, {
  id: 'existingCustomerPartnerServiceMaintenanceView',
  title: 'View mode for existing partner customer consent maintenance',
}, {
  id: 'migrationLifecycleFonicMobile',
  title: 'Migration Lifecycle Fonic Mobile',
}, {
  id: 'migrationLifecycleNetzclub0_9',
  title: 'Migration Lifecycle Netzclub Network 0.9',
}, {
  id: 'migrationLifecycleNetzclub1_0',
  title: 'Migration Lifecycle Netzclub Network 1.0',
}, {
  id: 'migrationLifecycleNetzclub1_1',
  title: 'Migration Lifecycle Netzclub Network 1.1',
}, {
  id: 'migrationLifecycleFonic',
  title: 'Migration Lifecycle Fonic',
}, {
  id: 'existingCustomerPackBooking',
  title: 'Pack booking for existing customers',
}, {
  id: 'existingCustomerAgentCampaign',
  title: 'Agent campaign for existing customers',
}, {
  id: 'existingCustomerSMSCampaign',
  title: 'SMS Campaign for existing Customers',
}];
